import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/site/Layout";
import { blogPosts } from "../data/mock";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("ro-RO", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

const Blog = () => {
  return (
    <>
      <section className="page-hero">
        <div className="site-container">
          <h1>Noutăți</h1>
          <p>
            Articole pe teme practice — contabilitate primară, resurse
            umane și termene fiscale. Informații utile pentru
            administratori și antreprenori.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="site-container">
          <div className="blog-grid">
            {blogPosts.map((p, i) => (
              <Reveal key={p.id} delay={i * 130}>
                <Link to={`/noutati/${p.slug}`} className="blog-card" data-testid={`blog-card-${p.slug}`}>
                  <div className="blog-card-image">
                    <img src={p.image} alt={p.title} loading="lazy" />
                  </div>
                  <div className="blog-card-meta">
                    {p.category} · {formatDate(p.date)}
                  </div>
                  <h3 className="blog-card-title">{p.title}</h3>
                  <p className="blog-card-excerpt">{p.excerpt}</p>
                  <span className="blog-card-more">Mai mult →</span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
